module.exports = __webpack_public_path__ + "static/media/trainerThree.81e56a6d.jpg";